// Insert a divider when consecutive messages are at least this far apart.
// 30 minutes mirrors the gap most chat UIs treat as a "new conversation
// session" without being so chatty that every back-and-forth gets a header.
export const TIME_DIVIDER_THRESHOLD_MS = 30 * 60 * 1000;

// Persisted messages carry an ISO `createdAt` (see SalesInsightMessageSchema)
// but the AI SDK `UIMessage` type doesn't surface it. The field is always
// present at runtime for rehydrated messages, so we read it via a structural
// type instead of fighting the SDK generics.
export type WithCreatedAt = { createdAt?: unknown };

export function parseMessageTime(m: WithCreatedAt): number | null {
  const raw = m.createdAt;
  if (typeof raw !== "string" || raw.length === 0) return null;
  const t = Date.parse(raw);
  return Number.isFinite(t) ? t : null;
}

const dividerFormatter = new Intl.DateTimeFormat("sv-SE", {
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

const timeOnlyFormatter = new Intl.DateTimeFormat("sv-SE", {
  hour: "2-digit",
  minute: "2-digit",
});

function isSameLocalCalendarDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function formatDividerLabel(t: number): string {
  const d = new Date(t);
  if (isSameLocalCalendarDay(d, new Date())) {
    return timeOnlyFormatter.format(d);
  }
  // sv-SE renders e.g. "21 apr. 17:00" for the chosen options.
  return dividerFormatter.format(d);
}
